import text from './resources/locale/en.json';

class PhoneFilterView {
    $onInit() {
        this.text = text;
    }
}

export default PhoneFilterView;
